import { Typography } from "@mui/material";
import { StepperNavBackgroundWrapper } from "./project-header.style";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";
import { Button } from "../../../../components/button/button";
import { EditIcon } from "../../../../utils/svg-components";
import { useAuth } from "../../../../context/AuthContext";
import { EncircledPlusIcon } from "../../../../utils/svg-components";
import { CircularIconButton } from "../../../../components/circular-button/circular-button.styles";

const ProjectHeader = (props) => {
  const {
    projectDetails,
    activeTab,
    isEditMode,
    setIsEditMode,
    isSaving,
    handleSave,
    setIsAddLinkModalOpen,
    companyData,
  } = props;

  const { userPermissions } = useAuth();

  const clientName = companyData?.[projectDetails?.client];

  const navigate = useNavigate();
  return (
    <StepperNavBackgroundWrapper>
      <div className="flex">
        <CircularIconButton onClick={() => navigate(-1 || "/projectsView")}>
          <ChevronLeft />
        </CircularIconButton>
        <div>
          <div className="head-flex">
            <Typography variant="h5">{projectDetails?.projectName}</Typography>
          </div>
          <div className="head-flex">
            <Typography variant="body3">
              {`ID: ${projectDetails?.id} `}
              {projectDetails?.client ? `| Client: ${clientName}` : ""}
            </Typography>
          </div>
        </div>
      </div>
      <div>
        {/* {activeTab === "project-health" && (
          <div>
            <Button
              variant="filled"
              color={"tertiary"}
              size="medium"
              onClick={() => setIsEditMode(true)}
              startIcon={<DownloadIcon />}
            >
              Download Financials CSV
            </Button>
          </div>
        )} */}
        {activeTab === "projects-assets" && (
          <div>
            <Button
              variant="filled"
              color={"tertiary"}
              size="medium"
              onClick={() => setIsAddLinkModalOpen(true)}
              startIcon={<EncircledPlusIcon />}
            >
              Add Link
            </Button>
          </div>
        )}
        {activeTab === "basic-info" && (
          <div>
            {userPermissions !== "General" && !isEditMode && (
              <Button
                variant="filled"
                color={"tertiary"}
                size="medium"
                onClick={() => setIsEditMode(true)}
                startIcon={<EditIcon />}
              >
                Edit Project
              </Button>
            )}

            {userPermissions !== "General" && isEditMode && (
              <Button
                variant="filled"
                color={"tertiary"}
                size="medium"
                onClick={handleSave}
                startIcon={<EditIcon />}
                isLoading={isSaving}
              >
                Save Project
              </Button>
            )}
          </div>
        )}
      </div>
    </StepperNavBackgroundWrapper>
  );
};

export default ProjectHeader;
